import React from 'react'
import { connect } from 'react-redux'
import { localized } from '@/decorators/localized'
import { actionCreators } from '@/store/Password'
import { WhiteBox } from '@/components/Layout'
import LoadingIndicator from '@/components/LoadingIndicator'
import ChangePasswordForm from './form'

@localized()
class ChangePassword extends React.Component {
  componentWillMount () {
    this.props.getPasswordValidity()
  }
  renderContent () {
    const { fetching, changing } = this.props
    const loading = fetching || changing
    if (loading) { return <LoadingIndicator /> }
    const { componentKey, ...otherProps } = this.props
    return <ChangePasswordForm key={componentKey} {...otherProps} />
  }
  render () {
    return (
      <WhiteBox
        className='ChangePassword'
        header='Security.ChangePassword'>
        {this.renderContent()}
      </WhiteBox>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...state.password,
  ...ownProps
})

const mapDispatchToProps = {
  getPasswordValidity: actionCreators.getPasswordValidity,
  changePassword: actionCreators.changePassword
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword)



// WEBPACK FOOTER //
// ./src/components/userProfile/changePassword/index.js